/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

import axios from "axios";

import ServiceConstant from "@/app/core/ServiceConstant";

export default class MainService {
  static serviceConstant = ServiceConstant;
  static config = {
    headers: {
      Authorization: sessionStorage.tokenUser,
    },
  };
  static configPDF = {
    headers: {
      Authorization: sessionStorage.tokenUser,
    },
    responseType: "blob",
  };

  static configFILE = {
    headers: {
      Authorization: sessionStorage.tokenUser,
    },
    "Content-Type": "multipart/form-data",
  };

  static postSEC(path, data) {
    return axios.post(path, data, {
      headers: {
        Authorization: sessionStorage.tokenUser,
      },
    });
  }

  static postPDFSEC(path, data) {
    return axios.post(path, data, {
      headers: {
        Authorization: sessionStorage.tokenUser,
      },
      responseType: "blob",
    });
  }
  static postZipSEC(path, data) {
    return axios.post(path, data, {
      headers: {
        Authorization: sessionStorage.tokenUser,
      },
      responseType: "blob",
    });
  }

  static postFILESEC(path, data) {
    return axios.post(path, data, {
      headers: {
        Authorization: sessionStorage.tokenUser,
      },
      "Content-Type": "multipart/form-data",
    });
  }

  static getSEC(path) {
    return axios.get(path, {
      headers: {
        Authorization: sessionStorage.tokenUser,
      },
    });
  }

  static getUN(path, data) {
    return axios.get(path, data, config);
  }
  static postUN(path, data) {
    return axios.post(path, data, config);
  }
}
